// SectionCard.jsx
const SectionCard = ({ title, children, icon }) => {
  return (
    <div
      className="
        rounded-3xl p-6
        bg-gradient-to-br from-[#081A3A] to-blue-600
        shadow-2xl
        text-white
        transition-all duration-300
        hover:shadow-blue-500 hover:-translate-y-1
      "
    >
      <h3 className="text-xl text-start  whitespace-pre-line leading-tight font-semibold tracking-wide flex items-start gap-2 mb-6">
        {icon && (
          <div className="mb-3 p-3 rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 group-hover:rotate-6 transition-all duration-500">
            {icon}
          </div>
        )}
        {title}
      </h3>

      <div className="grid gap-4">{children}</div>
    </div>
  );
};

export default SectionCard;
